module.exports = __webpack_public_path__ + "d583ce4b9bd2c4415c1f6ce91c65d78e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/owner/remove/remove-account-owner.html
// module id = 1764
// module chunks = 0